// Querys and Mutations
import {
    ALL_ACTIVE,
    CHANGE_STATUS,
    CREATE,
    UPDATE,
    GET_WITH_PAGINATION,
    DELETE
} from '@/graphql/config/AfpGraphql'

// models
import { ResponseDefault, Paginator } from '@/models'
import { AfpModel, AfpForm, AfpsWithPagination } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class AfpService {
    /**
     * Queries
     */
    async getActivated (): Promise<AfpModel[]> {
        const result = await apolloClient.query({
            query: ALL_ACTIVE
        })
        return result.data.afpsActive
    }

    async getWithPagination (perPage = 10, page = 1): Promise<AfpsWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage
            }
        })
        const pagination: Paginator = result.data.afpsWithPagination.paginatorInfo
        const data: [AfpModel] = result.data.afpsWithPagination.data
        const response: AfpsWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    /**
     * Mutations
     */
     async create (form: AfpForm): Promise<AfpModel> {
        const result = await apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: form
            }
        })
        return result.data.createAfp
    }

    async update (id: number, form: AfpForm): Promise<AfpModel> {
        const result = await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: form
            }
        })
        return result.data.updateAfp
    }

    async changeStatus (id: number, status: boolean): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: CHANGE_STATUS,
            variables: {
                id: id,
                input: {
                    is_active: status
                }
            }
        })
        return {
            success: true,
            errors: []
        }
    }

    async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
    }
}

export default new AfpService()
